import type { ProjectReader } from '@/api/client';

/** Кусок книги чтеца, номерами страниц книги, включая обе границы */
export interface ReaderPageSpan {
  from: number;
  to: number;
}

export type ReaderPagesFields = Pick<ProjectReader, 'reader_pages' | 'reader_start_page' | 'reader_end_page'>;

const positive = (value: number | string | null | undefined): number | null => {
  const n = Number(value);
  return value != null && value !== '' && Number.isInteger(n) && n > 0 ? n : null;
};

/**
 * Откуда считается прогресс чтеца (концепт reader-pages 5.1; на сервере то же правило — updateProjectReadersProgress):
 * своё число страниц — с 1-й по него; иначе диапазон (пустое начало — 1-я, пустой конец — последняя страница проекта);
 * иначе страницы проекта. null — считать не от чего (нет ни своих страниц, ни конца диапазона, ни страниц проекта).
 */
export function readerPageSpan(reader: ReaderPagesFields, projectPages: number | string | null | undefined): ReaderPageSpan | null {
  const own = positive(reader.reader_pages);
  if (own !== null) return { from: 1, to: own };
  const from = positive(reader.reader_start_page) ?? 1;
  const to = positive(reader.reader_end_page) ?? positive(projectPages);
  return to !== null && to >= from ? { from, to } : null;
}

/** Записано страниц своего куска: страница остановки (номером книги) внутри куска */
export function pagesReadInSpan(pagesRead: number, span: ReaderPageSpan): number {
  return Math.max(0, Math.min(pagesRead, span.to) - span.from + 1);
}
